import { Description } from '@/tools/itemProperties/Description';
import { propertyStyles as styles } from '@/tools/itemProperties/itemProperties.styles';
import type { DescriptionProps } from '@/tools/itemProperties/Description';

export type ItemDescriptionProps = DescriptionProps;

export const ItemDescription = (props: ItemDescriptionProps) => (
  <Description
    {...props}
    testId="itemDescription"
    editableContainerXstyle={styles.alternateProperty}
    editableLabelXstyle={[styles.propertyName, styles.alternateProperty]}
    editableValueXstyle={styles.propertyValue}
    readonlyContainerXstyle={styles.alternateProperty}
    readonlyLabelXstyle={[styles.propertyName, styles.alternateProperty]}
    readonlyValueXstyle={styles.propertyValue}
  />
);
